import { render, staticRenderFns } from "./PhuProduction.vue?vue&type=template&id=87e08284&scoped=true"
import script from "./PhuProduction.vue?vue&type=script&lang=js"
export * from "./PhuProduction.vue?vue&type=script&lang=js"
import style0 from "./PhuProduction.vue?vue&type=style&index=0&id=87e08284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e08284",
  null
  
)

export default component.exports